import { render, staticRenderFns } from "./EditUserCompanyDocumentsModal.vue?vue&type=template&id=97667c68&scoped=true&"
import script from "./EditUserCompanyDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./EditUserCompanyDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditUserCompanyDocumentsModal.vue?vue&type=style&index=0&id=97667c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97667c68",
  null
  
)

export default component.exports